import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import StandardModal from "./shared/StandardModal";
import Checkbox from "./shared/Checkbox";
import { PrimaryButton } from "./shared/button/PrimaryButton";
import { SecondaryButton } from "./shared/button/SecondaryButton";
import { useClassroomSessionStore } from "stores/v2/classroomSessionStore";

// Legacy .js file: explicit-module-boundary-types expects typed props and return on exports.

const OneActiveMonitorWarningModal = (props) => {
	const { t } = useTranslation();
	const [suppressWarning, setSuppressWarning] = useState(false);
	const [starting, setStarting] = useState(false);

	const startSession = () => {
		localStorage.setItem("hideMonitoringSessionWarning", suppressWarning);
		setStarting(true);
		props.onStart(useClassroomSessionStore.getState().getSavedExpiry());
	};

	const renderActions = () => {
		return (
			<div>
				<SecondaryButton className="mui-flat-button" label={t("classroomDetails.monitorWarningCancel")} onClick={props.onClose} />
				<PrimaryButton
					className="mui-flat-button"
					label={t("classroomDetails.monitorWarningContinue")}
					disabled={starting}
					onClick={startSession}
				/>
			</div>
		);
	};

	return (
		<StandardModal
			size="medium"
			title={t("classroomDetails.monitorWarningHeadsUp")}
			open={props.open}
			close={props.onClose}
			actions={renderActions()}
		>
			{t("classroomDetails.monitorWarningBody", { existingClassname: props.existingClassname })}
			<br />
			<br />
			<Checkbox
				checked={suppressWarning}
				onChecked={(isChecked) => setSuppressWarning(isChecked)}
				label={t("classroomDetails.monitorWarningDontShowAgain")}
			/>
		</StandardModal>
	);
};

export default OneActiveMonitorWarningModal;
